import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
    ApiResponse,
    HoleModel,
    HoleModelPagedResponseModel,
    QueryParams
} from '../models';

/**
 * Holes API Service
 */
@Injectable({
    providedIn: 'root'
})
export class HolesService extends BaseApiService {

    /**
     * Get all holes with pagination
     */
    getHoles(params?: QueryParams): Observable<ApiResponse<HoleModelPagedResponseModel>> {
        return this.get<HoleModelPagedResponseModel>('/holes', params);
    }

    /**
     * Get hole by ID
     */
    getHoleById(id: string): Observable<ApiResponse<HoleModel>> {
        return this.get<HoleModel>(`/holes/${id}`);
    }

    /**
     * Create new hole
     */
    createHole(hole: HoleModel): Observable<ApiResponse<HoleModel>> {
        return this.post<HoleModel>('/holes', hole);
    }

    /**
     * Update hole
     */
    updateHole(id: string, hole: HoleModel): Observable<ApiResponse<HoleModel>> {
        return this.put<HoleModel>(`/holes/${id}`, hole);
    }

    /**
     * Delete hole
     */
    deleteHole(id: string): Observable<ApiResponse<void>> {
        return this.delete<void>(`/holes/${id}`);
    }
}
